/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_List_Count_OneInputs */

const en_colleague_list_count_one = /** @type {(inputs: Colleague_List_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 ticket`)
};

const ja_colleague_list_count_one = /** @type {(inputs: Colleague_List_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チケット 1 件`)
};

const fr_colleague_list_count_one = /** @type {(inputs: Colleague_List_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 ticket`)
};

const de_colleague_list_count_one = /** @type {(inputs: Colleague_List_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Ticket`)
};

/**
* | output |
* | --- |
* | "1 ticket" |
*
* @param {Colleague_List_Count_OneInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_list_count_one = /** @type {((inputs?: Colleague_List_Count_OneInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_List_Count_OneInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_list_count_one(inputs)
	if (locale === "ja") return ja_colleague_list_count_one(inputs)
	if (locale === "fr") return fr_colleague_list_count_one(inputs)
	return de_colleague_list_count_one(inputs)
});